var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.700048 11.3008C0.516715 11.1174 0.425049 10.8841 0.425049 10.6008C0.425049 10.3174 0.516715 10.0841 0.700048 9.90078L4.60005 6.00078L0.700048 2.10078C0.516715 1.91745 0.425049 1.68411 0.425049 1.40078C0.425049 1.11745 0.516715 0.884114 0.700048 0.700781C0.883382 0.517448 1.11671 0.425781 1.40005 0.425781C1.68338 0.425781 1.91672 0.517448 2.10005 0.700781L6.70005 5.30078C6.80005 5.40078 6.87105 5.50911 6.91305 5.62578C6.95438 5.74245 6.97505 5.86745 6.97505 6.00078C6.97505 6.13411 6.95438 6.25911 6.91305 6.37578C6.87105 6.49245 6.80005 6.60078 6.70005 6.70078L2.10005 11.3008C1.91672 11.4841 1.68338 11.5758 1.40005 11.5758C1.11671 11.5758 0.883382 11.4841 0.700048 11.3008Z",
    fill: "#989899"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightChevron);
export default __webpack_public_path__ + "static/media/right-chevron.c19265445e3b2c1f01ac246a3bd9f75a.svg";
export { ForwardRef as ReactComponent };